import { render, staticRenderFns } from "./AppointmentsManagement.vue?vue&type=template&id=d652c944&"
import script from "./AppointmentsManagement.vue?vue&type=script&lang=js&"
export * from "./AppointmentsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports